/** État icône en attente (persistée au Save du formulaire, pas à la sélection). */
export const U3148_ORGANIZATION_ICON_PENDING_ATTR = "organizationIconPending";

export interface U3148OrganizationIconPendingState {
  pendingFile: File | null;
  pendingDelete: boolean;
  previewObjectUrl: string | null;
}

export const emptyOrganizationIconPending: U3148OrganizationIconPendingState = {
  pendingFile: null,
  pendingDelete: false,
  previewObjectUrl: null,
};

export function getOrganizationIconPending(customAttributes: Record<string, unknown>): U3148OrganizationIconPendingState {
  const raw = customAttributes[U3148_ORGANIZATION_ICON_PENDING_ATTR];
  if (!raw || typeof raw !== "object") {
    return { ...emptyOrganizationIconPending };
  }
  const state = raw as U3148OrganizationIconPendingState;
  return {
    pendingFile: state.pendingFile instanceof File ? state.pendingFile : null,
    pendingDelete: Boolean(state.pendingDelete),
    previewObjectUrl: typeof state.previewObjectUrl === "string" ? state.previewObjectUrl : null,
  };
}

export function hasOrganizationIconPendingChanges(state: U3148OrganizationIconPendingState): boolean {
  return Boolean(state.pendingFile) || state.pendingDelete;
}

export function revokeOrganizationIconPreview(state: U3148OrganizationIconPendingState): void {
  if (state.previewObjectUrl) {
    URL.revokeObjectURL(state.previewObjectUrl);
  }
}

export function mergeOrganizationIconPending(
  customAttributes: Record<string, unknown>,
  patch: Partial<U3148OrganizationIconPendingState>
): Record<string, unknown> {
  const current = getOrganizationIconPending(customAttributes);
  return {
    ...customAttributes,
    [U3148_ORGANIZATION_ICON_PENDING_ATTR]: { ...current, ...patch },
  };
}

export function clearOrganizationIconPendingAttributes(customAttributes: Record<string, unknown>): Record<string, unknown> {
  const pending = getOrganizationIconPending(customAttributes);
  revokeOrganizationIconPreview(pending);
  const next = { ...customAttributes };
  delete next[U3148_ORGANIZATION_ICON_PENDING_ATTR];
  return next;
}

/** URL d’aperçu : fichier en attente, sinon icône persistée si non marquée pour suppression. */
export function resolveOrganizationIconPreviewUrl(
  pending: U3148OrganizationIconPendingState,
  organizationIconUrl: string | null | undefined
): string | null {
  if (pending.previewObjectUrl) {
    return pending.previewObjectUrl;
  }
  if (pending.pendingDelete) {
    return null;
  }
  return organizationIconUrl ?? null;
}
